import { mdiDomain } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/components/administration"
import type { OrgaViewFrameContext } from "../../../../context"
import {
  canViewOrganizationSettings,
  canDeleteOrganization,
} from "../../../../_shared/_logic/access"

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "organization",
  title: "Organisation",
  tooltip: "Betriebs- und Kontaktdaten, Servicezeiten und den Auftritt im Kundenportal bearbeiten.",
  icon: mdiDomain,
  routeSegment: "organization",
  getPages: (context) => {
    if (!canViewOrganizationSettings(context)) return []

    return [
      {
        id: "organization",
        title: "Organisation",
        path: "",
        tabs: [
          {
            id: "general",
            title: "Allgemein",
            routeSegment: "general",
            widthType: "normal",
            testId: "controlAdmin.organizationView.tab.general",
          },
          ...(canDeleteOrganization(context)
            ? [
                {
                  id: "danger",
                  title: "Gefahrenzone",
                  routeSegment: "danger",
                  widthType: "small" as const,
                  testId: "controlAdmin.organizationView.tab.danger",
                },
              ]
            : []),
        ],
      },
    ]
  },
}
